/** @jsxImportSource @emotion/react */

import { ChangeEvent, useContext, useEffect, useState } from 'react';
import { Input as AntInput, InputProps } from 'antd';
import { ThemeContext } from 'contexts';
import { Icon } from '../Icon/Icon';

export const Input = ({ value, onChange, prefix, suffix, ...props }: InputProps) => {
  const { currentTheme } = useContext(ThemeContext);

  const [hasValues, setHasValue] = useState(false);

  useEffect(() => {
    const onSetInitialHasValues = () => {
      if (value) {
        setHasValue(true);
      }
    };

    onSetInitialHasValues();
  }, [value]);

  const onInputChange = (val: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(val);

    if (val.target.value) {
      setHasValue(true);

      return;
    }

    setHasValue(false);
  };

  return (
    <AntInput
      value={value}
      onChange={onInputChange}
      classNames={{
        prefix: hasValues ? 'ant-input-prefix-has-value' : undefined
      }}
      prefix={
        typeof prefix === 'string' ? (
          <Icon type={prefix} fill={hasValues ? currentTheme.colorPrimary : ''} />
        ) : (
          prefix
        )
      }
      suffix={
        typeof suffix === 'string' ? (
          <Icon type={suffix} fill={hasValues ? currentTheme.colorPrimary : ''} />
        ) : (
          suffix
        )
      }
      allowClear={{
        clearIcon: <Icon type="close-small" />
      }}
      {...props}
    />
  );
};
